<template>
    <div class="relative inline-block group" ref="container">
        <slot></slot>

        <div
            v-if="title"
            class="invisible group-hover:visible opacity-0 group-hover:opacity-100 absolute z-[9999] px-3 py-1.5 text-[11px] font-bold text-white bg-primary rounded-xl shadow-2xl transition-all duration-200 whitespace-nowrap pointer-events-none"
            :class="tooltipClasses"
        >
            <span v-if="html" v-html="title"></span>
            <span v-else>{{ title }}</span>

            <!-- Arrow -->
            <div
                class="absolute w-2 h-2 bg-primary rotate-45"
                :class="arrowClasses"
            ></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tooltip",
    props: {
        title: {
            type: String,
            default: "",
        },
        placement: {
            type: String,
            default: "top",
        },
        html: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        tooltipClasses() {
            switch (this.placement) {
                case "top":
                    return "bottom-full left-1/2 -translate-x-1/2 mb-2 -translate-y-1 group-hover:translate-y-0";
                case "bottom":
                    return "top-full left-1/2 -translate-x-1/2 mt-2 translate-y-1 group-hover:translate-y-0";
                case "left":
                    return "right-full top-1/2 -translate-y-1/2 mr-2 -translate-x-1 group-hover:translate-x-0";
                case "right":
                    return "left-full top-1/2 -translate-y-1/2 ml-2 translate-x-1 group-hover:translate-x-0";
                default:
                    return "bottom-full left-1/2 -translate-x-1/2 mb-2 -translate-y-1 group-hover:translate-y-0";
            }
        },
        arrowClasses() {
            switch (this.placement) {
                case "top":
                    return "bottom-[-4px] left-1/2 -translate-x-1/2";
                case "bottom":
                    return "top-[-4px] left-1/2 -translate-x-1/2";
                case "left":
                    return "right-[-4px] top-1/2 -translate-y-1/2";
                case "right":
                    return "left-[-4px] top-1/2 -translate-y-1/2";
                default:
                    return "bottom-[-4px] left-1/2 -translate-x-1/2";
            }
        },
    },
};
</script>
